export enum AccountConst {
    IndividualAccount = 'Individual Account',
    Prospect = 'prospect',
    Prospects = 'prospects',
    Propspect = 'propspect'
}

export enum Sections {
    CONTACT_DETAILS = 'Contact Details',
    ACCOUNT_INFORMATION = 'Account Information',
    ACCOUNT_DETAILS = 'Account Details',
    ADDRESS_DETAILS = 'Address Details'
}

export const FileMimeTypes = [
    { extension: "csv", value: "text/csv;charset=utf-8" },
    { extension: "doc", value: "application/msword;charset=utf-8" },
    { extension: "gif", value: "image/gif;charset=utf-8" },
    { extension: "jpeg", value: "image/jpeg;charset=utf-8" },
    { extension: "jpg", value: "image/jpeg;charset=utf-8" },
    { extension: "png", value: "image/png;charset=utf-8" },
    { extension: "pdf", value: "application/pdf;charset=utf-8" },
    { extension: "ppt", value: "application/vnd.ms-powerpoint;charset=utf-8" },
    { extension: "rar", value: "application/x-rar-compressed;charset=utf-8" },
    { extension: "xls", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
    { extension: "xlsx", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
    { extension: "zip", value: "application/zip;charset=utf-8" },
    { extension: "txt", value: "text/plain;charset=utf-8" }
];

export const EmailFields: string[] = ['contactWorkEmail', 'contactHomeEmail', 'contactCE1Email', 'contactCE2Email', 'accountEmail'];
export const EmailFieldsMain: string[] = ['contactWorkEmail', 'contactHomeEmail', 'accountEmail'];

export const PhoneFields: string[] = ['contactWorkPhone', 'contactMobilePhone', 'contactHomePhone', 'contactCP1Phone',
    'contactCP2Phone', 'accountPhone'];

export const SocialFields: string[] = [ 'contactSocialWebsite', 'contactSocialFacebook', 'contactSocialTwitter', 'contactSocialLinkedIn',
    'contactSocialInstagram', 'accountSocialWebsite', 'accountSocialFacebook', 'accountSocialTwitter', 'accountSocialLinkedIn',
    'accountSocialWebsite' ];

export const DropdownFields: string[] = [
    'accountSourceId',
    'accountTypeIds',
    'annualRevenueId',
    'contactJobFunctionIds',
    'contactSalutationId',
    'currencyId',
    'industryId',
    'numberOfEmployeesId',
    'ownershipTypeId',
    'ratingId',
    'stageId',
    'timezoneId',
    'ownerId'
];

export const ContactEmailFields: string[] = [ 'emailTypeId', 'emailAddress' ];

export const ContactPhoneFields: string[] = [ 'phoneTypeId', 'phoneNumber', 'code', 'country' ];

export const ContactSocialFields: string[] = [ 'socialProfileTypeId', 'socialProfileAddress' ];

export const AccountNameFields: string[] = ['contactFirstName', 'contactMiddleName', 'contactLastName', 'accountName'];

export const AddressFields: string[] = [ 'addressTypeId', 'addressClassId', 'streetAddress1', 'streetAddress2', 'addressName', 'countryId',
    'cityId', 'stateId', 'zipCode', 'attnId', 'isActive', 'isDefault',  'latitude', 'longitude'
];

export const CustomAttributeFields: string[] = [ 'id', 'values', 'attachments' ];
